import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {DropdownsModel, ListSiteGroupModel, SiteContactsModel, PurchaseOrderModel, SiteContractModel} from "./assets-dropdowns-info-model";

@Injectable()
export class SiteWorkflowService {
  private url: string = "/api/sites";

  constructor(private http: HttpClient) {}

  sendDARTCorrectionRequest(
    description: string,
    projectId: string,
    dealId: string,
  ): Promise<boolean> {
    return this.http.post(`${this.url}/request-dart-correction/${projectId}`, {description, dealId})
      .pipe(map(obj => !!obj["success"]))
      .toPromise();
  }

  getProducts(deviceId: string): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/products/${deviceId}`)
      .toPromise();
  }

  getAssetsDropdownData(siteId: string, projectId: string): Promise<{
    dropdownGroupsList: ListSiteGroupModel[];
    dropdowns: DropdownsModel;
    dropdownSiteContacts: SiteContactsModel[];
    dropdownPurchaseOrders: PurchaseOrderModel[];
    dropdownContractList: SiteContractModel[];
  }> {
    return this.http.get<{
      dropdownGroupsList: ListSiteGroupModel[];
      dropdowns: DropdownsModel;
      dropdownSiteContacts: SiteContactsModel[];
      dropdownPurchaseOrders: PurchaseOrderModel[];
      dropdownContractList: SiteContractModel[];
    }>(`${this.url}/get-assets-dropdown-data/${siteId}/${projectId}`).toPromise();
  }
}
